module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-VC.a5f5421c.png";